import { ActionTypes, AlertTypes } from '@tassat/ui-definitions';

import { ConfirmationWorkflowState, DEFAULT_INITIAL_STATE } from './ConfirmationWorkflowContext';

export const resetAlertModal: Partial<ConfirmationWorkflowState> = {
    alertModalType: AlertTypes.message,
    alertModalOpen: false,
    validated: false,
    validationTitle: '',
    validationMessage: '',
    actionInProgress: false,
    successTitle: '',
    successBody: '',
    failureTitle: '',
    failureBody: ''
};

export type ConfirmationWorkflowAction = {
    type: 'CONFIGURE_WORKFLOW';
    workflowConfiguration: {
        selectedItem?: any;
        setSelectedItem?: ((data) => void) | null;
        preActionValidationAndConfig: {
            [key in ActionTypes]?: (data) => Promise<boolean> | boolean;
        };
        onConfirm: {
            [key in ActionTypes]?: (data) => Promise<any> | null;
        };
        useTimeout?: boolean;
    };
} |
{
    type: 'VALIDATION_SUCCESS';
    workflowConfiguration: {
        selectedItem: any;
        actionType: ActionTypes;
        confirmTitle: string;
        confirmBody: string | React.ReactElement;
    };
} |
{
    type: 'VALIDATION_FAILED';
    workflowConfiguration: {
        validationTitle: string;
        validationMessage: string | React.ReactElement;
    };
} |
{
    type: 'SERVER_SUCCESS';
    workflowConfiguration: {
        successTitle: string;
        successBody: string | React.ReactElement;
    };
} |
{
    type: 'SERVER_ERROR';
    workflowConfiguration: {
        failureTitle: string;
        failureBody: string | React.ReactElement;
    };
} |
{
    type: 'SERVER_TIMEOUT';
    workflowConfiguration: {
        failureTitle: string;
        failureBody: string | React.ReactElement;
    };
} |
{ type: 'CLOSE_ALERT_MODAL' } |
{ type: 'CLOSE_CONFIRM_MODAL' } |
{ type: 'ACTION_CONFIRMED' };

export const ConfirmationWorkflowReducer = (
    state: ConfirmationWorkflowState,
    action: ConfirmationWorkflowAction
): ConfirmationWorkflowState => {
    switch (action.type) {
        case 'CONFIGURE_WORKFLOW':
            return {
                ...state,
                ...DEFAULT_INITIAL_STATE,
                selectedItem: action.workflowConfiguration.selectedItem,
                setSelectedItem: action.workflowConfiguration.setSelectedItem || null,
                preActionValidationAndConfig: action.workflowConfiguration.preActionValidationAndConfig,
                onConfirm: action.workflowConfiguration.onConfirm,
                useTimeout: action.workflowConfiguration.useTimeout || false
            };
        case 'VALIDATION_SUCCESS':
            return {
                ...state,
                ...resetAlertModal,
                validated: true,
                confirmModalOpen: true,
                selectedItem: action.workflowConfiguration.selectedItem,
                actionType: action.workflowConfiguration.actionType,
                confirmTitle: action.workflowConfiguration.confirmTitle,
                confirmBody: action.workflowConfiguration.confirmBody
            };
        case 'VALIDATION_FAILED':
            return {
                ...state,
                ...resetAlertModal,
                alertModalOpen: true,
                validationTitle: action.workflowConfiguration.validationTitle,
                validationMessage: action.workflowConfiguration.validationMessage
            };
        case 'SERVER_SUCCESS':
            return {
                ...state,
                ...resetAlertModal,
                selectedItem: null,
                alertModalOpen: true,
                confirmModalOpen: false,
                alertModalType: AlertTypes.success,
                successTitle: action.workflowConfiguration.successTitle,
                successBody: action.workflowConfiguration.successBody
            };
        case 'SERVER_ERROR':
            return {
                ...state,
                ...resetAlertModal,
                selectedItem: null,
                alertModalOpen: true,
                confirmModalOpen: false,
                alertModalType: AlertTypes.failure,
                failureTitle: action.workflowConfiguration.failureTitle,
                failureBody: action.workflowConfiguration.failureBody
            };
        case 'SERVER_TIMEOUT':
            return {
                ...state,
                ...resetAlertModal,
                selectedItem: null,
                alertModalOpen: true,
                confirmModalOpen: false,
                alertModalType: AlertTypes.timeout,
                failureTitle: action.workflowConfiguration.failureTitle,
                failureBody: action.workflowConfiguration.failureBody
            };
        case 'CLOSE_ALERT_MODAL':
            return {
                ...state,
                alertModalOpen: false
            };
        case 'CLOSE_CONFIRM_MODAL':
            return {
                ...state,
                confirmModalOpen: false
            };
        case 'ACTION_CONFIRMED':
            return {
                ...state,
                actionInProgress: true
            };
        default:
            return state;
    }
};